"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ColorType;
(function (ColorType) {
    ColorType["Green"] = "green";
    ColorType["LightGreen"] = "light-green";
    ColorType["DarkBlue"] = "dark-blue";
    ColorType["ShadowBlue"] = "shadow-blue";
    ColorType["AntracitBlue"] = "antracit-blue";
    ColorType["Blue"] = "blue";
    ColorType["LightBlue"] = "light-blue";
    ColorType["StrongGrey"] = "strong-grey";
    ColorType["MidGrey"] = "mid-grey";
    ColorType["LightGrey"] = "light-grey";
    ColorType["VeryLightGrey"] = "very-light-grey";
    ColorType["ButtonGrey"] = "button-grey";
    ColorType["White"] = "white";
    ColorType["Purple"] = "purple";
    ColorType["Red"] = "red";
    ColorType["Orange"] = "orange";
})(ColorType || (ColorType = {}));
exports.default = ColorType;
